var _title, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const Svg36 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 90.1 91",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "36")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_4",
    "data-name": "Capa 4"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M80.76,76.74a4.89,4.89,0,0,1-2.68,3.52,4.5,4.5,0,0,1-4.79-.5,8.25,8.25,0,0,1-.93-.84L61.06,67.63l-.57-.55C52.7,72.85,44.05,75,34.55,73a30.66,30.66,0,0,1-19-12.18A31.73,31.73,0,1,1,67,60.32c.16.17.32.36.5.53,3.65,3.65,7.28,7.31,11,10.94a7.33,7.33,0,0,1,2.33,3.55Zm-39.66-59A24.27,24.27,0,1,0,65.36,42,24.31,24.31,0,0,0,41.1,17.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M39.79,21.49c7.56.49,13.21,4,16.72,10.76a3.72,3.72,0,0,1-6.56,3.48,13.06,13.06,0,0,0-4.16-4.79A11.47,11.47,0,0,0,40.26,29a12.11,12.11,0,0,1-1.94-.21,3.65,3.65,0,0,1-2.78-4.09,3.69,3.69,0,0,1,3.62-3.23Z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(Svg36, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/36.3a35c27a.svg";
export { ForwardRef as ReactComponent };